import { createAction, props } from '@ngrx/store';
import { Provider } from '../../interfaces/provider.interface';


// Register
export const registerSuperAdmin = createAction(
  '[Provider] Register Super Admin',
  props<{ requestBody: any, uploadedDocumentIds: any }>()
);

export const registerSuperAdminSuccess = createAction(
  '[Provider] Register Super Admin Success',
  props<{ response: any }>()
);
export const registerSuperAdminFailure = createAction(
  '[Provider] Register Super Admin Failure',
  props<{ error: any, uploadedDocumentIds: any }>()
);

// Get All Providers
export const loadAllProviders = createAction(
  '[Provider] Load All Providers',
  props<{ filters?: any }>() // <-- supports optional query filters
);

export const loadAllProvidersSuccess = createAction(
  '[Provider] Load All Providers Success',
  props<{ providers: Provider[] }>()
);

export const loadAllProvidersFailure = createAction(
  '[Provider] Load All Providers Failure',
  props<{ error: string }>()
);

// Get Provider by ID
export const loadProviderById = createAction(
  '[Provider] Load Provider By ID',
  props<{ id: number }>()
);
export const loadProviderByIdSuccess = createAction(
  '[Provider] Load Provider By ID Success',
  props<{ provider: Provider }>()
);
export const loadProviderByIdFailure = createAction(
  '[Provider] Load Provider By ID Failure',
  props<{ error: string }>()
);

// Delete Provider
export const deleteProviderById = createAction(
  '[Provider] Delete Provider By ID',
  props<{ id: number }>()
);
export const deleteProviderByIdSuccess = createAction(
  '[Provider] Delete Provider By ID Success',
  props<{ response: any }>()
);
export const deleteProviderByIdFailure = createAction(
  '[Provider] Delete Provider By ID Failure',
  props<{ error: string }>()
);


export const clearLoadedProvider = createAction('[Provider] Clear Loaded Provider');
